// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"3779e8be","407":"4c52a357","453":"7e0e7a02","827":"a1cd0e1e","966":"307dea59"}[chunkId] + ".chunk.js";
};